import {dateFormatter} from 'components/Inputs/Dates/utils/dateformatter';

const defaultParams = {
  locale: 'ru',
  calendarParams: {
    dateInputDelimiter: '.',
    dateInputPattern: ['d', 'm', 'Y'],
    dateInputPatternShort: ['d', 'm', 'y'],
    dateInputPlaceholder: 'ДД.ММ.ГГ'
  },
  dateformatter: (key) => dateFormatter[key]
};

export default defaultParams;
